interface String {
	toPascalCase(): string;
	toCamelCase(): string;
}

/**
 * @description This File holds methods which will extend some JavaScript standard objects, like the JavaScript String prototype Object.
 * @author Robin Dürhager
 */

/**
 * @description Adds a toPascalCase / UpperCamelCase function to the String prototype Object. This Method has Problems with umlauts.
 * @example 'ich bin robin'.toPascalCase() wird zu Ich Bin Robin
 * @returns {string} The input String in PascalCase / UpperCamelCase
 */
String.prototype.toPascalCase = function() {
	return this.replace(/(?:^\w|[A-Z]|\b\w)/g, word => {
		return word.toUpperCase();
	});
};

/**
 * @description Adds a toCamelCase function to the String prototype Object. This Method has Problems with umlauts.
 * @returns {string} The input String in CamelCase
 */
String.prototype.toCamelCase = function() {
	return this.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
		return index === 0 ? word.toLowerCase() : word.toUpperCase();
	}).replace(/\s+/g, '');
};
